var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['c--shared_page-title', 'page-header-wrapper', {
      'mobile-header-wrapper': _vm.deviceType.isMobile,
      'border-md-b border-md-b-solid color-border-bottom-light': !_vm.deviceType.isMobile && _vm.bordered
    }]
  }, [_c('div', {
    class: ['page-header relative pb-20', {
      'pb-sm-30 pb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    staticClass: "airgsm-container page-header-title relative"
  }, [_vm.backButton ? [_c('nuxt-link', {
    class: ['page-header-title-back', {
      'display-inline-flex': _vm.deviceType.isMobile,
      'display-sm-none': _vm.backButton.hiddenAfterSizes === 'sm' && !_vm.deviceType.isMobile,
      'display-md-none': _vm.backButton.hiddenAfterSizes === 'md' && !_vm.deviceType.isMobile,
      'display-lg-none': _vm.backButton.hiddenAfterSizes === 'lg' && !_vm.deviceType.isMobile
    }],
    attrs: {
      "to": _vm.localePath(_vm.backButton.url)
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "image",
      "loader": "data",
      "name": "ic_back_header",
      "theme": "light"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _vm.titleTag === 'h2' ? _c('h2', {
    class: ['text-center mb-0', Object.assign({
      'typo-page-title-small px-20': _vm.deviceType.isMobile,
      'typo-sm-page-title-medium typo-md-page-title-big px-20 px-sm-48': !_vm.deviceType.isMobile
    }, _vm.isGeneralHeadTitle && {
      'general-title': _vm.isGeneralHeadTitle
    })]
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _c('h1', {
    class: ['text-center mb-0', Object.assign({
      'typo-page-title-small px-20': _vm.deviceType.isMobile,
      'typo-sm-page-title-medium typo-md-page-title-big px-20 px-sm-48': !_vm.deviceType.isMobile
    }, _vm.isGeneralHeadTitle && {
      'general-title': _vm.isGeneralHeadTitle
    })],
    attrs: {
      "data-testid": `${_vm.title}-title`
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])], 2), _vm._v(" "), _vm._t("subTitle")], 2), _vm._v(" "), _vm._t("bottom")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }